import { Grid, IconButton, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import AtlasPanel from "../../atlas/blades/AtlasPanel";

const DatasetDetails: React.FC<any> = ({
  theme,
  project,
  process,
  dataset,
}) => {
  if (dataset === null) return <Fragment />;

  return (
    <AtlasPanel title={dataset.name}>
      <Grid container spacing={3} style={{ fontSize: 13 }}>
        <Grid item xs={12} lg={8}>
          <div className="portalLabel">{process.name}</div>
          <div className="portalCopy">{process.desc || "Not Availible"}</div>
        </Grid>
        <Grid item xs={12} lg={2}>
          <div className="portalLabel">Project</div>
          <div className="portalCopy">
            <a href={`/portal/project/${project.id}`}>{project.name}</a>
          </div>
        </Grid>
        <Grid item xs={12} lg={2}>
          <div className="portalLabel">Status</div>
          <div className="portalCopy">{dataset.status}</div>
        </Grid>
      </Grid>
    </AtlasPanel>
  );
};

export default DatasetDetails;
